import { AntForm } from './styles';

export default AntForm;
